import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RegionVariantService } from 'app/core/region-variant/region-variant.service';
import { Subject, takeUntil } from 'rxjs';

interface AddMenuItem {
  description: string;
  action: () => void;
  dataCY: string;
  regionVariantConditional?: string;
}

@Component({
  selector: 'add-menu',
  templateUrl: './add-menu.component.html',
})
export class AddMenuComponent implements OnDestroy {
  private unsubscribeAll$: Subject<void> = new Subject();

  private baseMenuItems: AddMenuItem[] = [
    {
      description: 'Add Job',
      action: () => this.addJob(),
      dataCY: 'addJobItem',
      regionVariantConditional: 'addMenu.addJob',
    },
    {
      description: 'Add User',
      action: () => this.addUser(),
      dataCY: 'addUserItem',
      regionVariantConditional: 'addMenu.addUser',
    }
  ];

  menuItems: AddMenuItem[] = [];

  constructor(private router: Router, private regionVariantService: RegionVariantService) {
    this.regionVariantService.changes$
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe(() => this.calculateMenuItems());

    this.calculateMenuItems();
  }

  calculateMenuItems(): void {
    this.menuItems = this.baseMenuItems
      .filter((mi) => !mi.regionVariantConditional || this.regionVariantService.show(mi.regionVariantConditional));
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }

  addJob(): void {
    this.router.navigate(['/apps/add-job']);
  }

  addUser(): void {
    this.router.navigate(['/apps/userconsole']);
  }
}
